import { Component, Prop, State, Watch, h } from '@stencil/core';
import QRCode from 'qrcode';

@Component({
  tag: 'pn-qr-code-generator',
  styleUrl: 'pn-qr-code-generator.scss'
})
export class QrCodeGenerator {
  @Prop() url: string;
  @Prop() countdownSeconds: number = -1;
  @Prop() outdatedMessage: string;
  @Prop() expiresInMessage: string;
  @Prop() updateCodeEverySecond: boolean = true;
  @Prop() ariaLabel: string;

  @State() remainingSeconds: number;
  @State() isOutdated: boolean = false;
  @State() isFullscreen: boolean = false;

  private canvasRef: HTMLCanvasElement;
  private timer: any;
  private urlWithSegment: string;

  private readonly gray900: string = '#2d2013';
  private readonly blackHex: string = '#000';
  private readonly whiteHex: string = '#fff';

  connectedCallback() {
    this.isOutdated = false;

    if (this.timer == null) {
      this.generateQRCode();
      if (this.countdownSeconds !== -1) {

        requestAnimationFrame(() => {
          this.startCountdown();
        });
      }
    }
  }

  componentWillLoad() {
    this.urlWithSegment = this.url + '#';
    this.remainingSeconds = this.countdownSeconds;
    if(this.timer != null) {
      this.resetCountdown();
    }
  }

  disconnectedCallback() {
    this.resetCountdown();
  }

  private resetCountdown() {
    if (this.timer !== null) {
      this.remainingSeconds = this.countdownSeconds;
      clearInterval(this.timer);
      this.timer = null;
      return;
    }
  }

  @Watch('url')
  generateQRCode(urlSegment: string = '') {
    if (this.url && this.canvasRef) {
      this.urlWithSegment += urlSegment;
      QRCode.toCanvas(this.canvasRef, this.urlWithSegment, {
        width: 200,
        color: {
          dark: this.isOutdated ? this.gray900 : this.blackHex,
          light: this.isOutdated ? this.gray900 : this.whiteHex,
        },
      }, error => {
        if (error) console.error(error);
      });
    }
  }

  startCountdown() {
    this.timer = setInterval(() => {
      if (this.remainingSeconds > 0) {
        this.remainingSeconds--;
        this.generateQRCode('p');
      } else {
        clearInterval(this.timer);
        this.isOutdated = true;
        this.generateQRCode();
      }
    }, 1000);
  }


  render() {
    return (
      <div>
        <button class="qr-button__wrapper" aria-label={this.ariaLabel}>
          <canvas
            class={this.isOutdated ? 'outdated' : ''}
            ref={el => (this.canvasRef = el)}>
          </canvas>
        </button>
        {this.countdownSeconds !== -1 && <div class="timer">
          {this.isOutdated && <span class="outdated-message">{this.outdatedMessage}</span>}
          {!this.isOutdated && this.expiresInMessage && <span>{this.expiresInMessage} {this.remainingSeconds}</span>}
        </div>}
      </div>
    );
  }
}